<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <cohorts-clear></cohorts-clear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CohortsClear from './cohorts/CohortsClear';

    export default {

        components: {
            CohortsClear
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.cohorts'),
                        route: '/socrates/ui/accounts/cohorts'
                    },
                    {
                        name: this.$t('common.outdated'),
                    },
                ]
            }
        },
    }
</script>
